module.exports = "<nav class=\"nav-tabs\">\n  <ul>\n    <li><a ui-sref=\"dashboard.main\" ui-sref-active=\"active\" ui-sref-active-eq class=\"icon-home\">Dashboard</a></li>\n    <li><a ui-sref=\"dashboard.movements\" ui-sref-active=\"active\" ui-sref-active-eq class=\"icon-menu\">Lista Movimenti</a></li>\n    <li><a ui-sref=\"dashboard.pos\" ui-sref-active=\"active\" ui-sref-active-eq class=\"icon-invoice\">Web POS Report</a></li>\n  </ul>\n</nav>\n\n<div class=\"nav-tabs-contents\">\n  <div class=\"page-content\" ui-view></div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/dashboard/dashboard.html
 ** module id = 396
 ** module chunks = 0
 **/